import moment from 'moment';

    export default function(date) {
        // fuzzy date string, 'a long time ago...'
        // interesting note, undefined returns "As of in a few seconds"
        // which is in the future
        return moment(date).fromNow();
    }

